import script from "./align-disks.vue?vue&type=script&setup=true&lang=ts"
export * from "./align-disks.vue?vue&type=script&setup=true&lang=ts"

import "./align-disks.vue?vue&type=style&index=0&id=596687f4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596687f4"]])

export default __exports__